import { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://app-medifyhc.com';

export const useSubscriptionFeatures = () => {
  const [features, setFeatures] = useState({
    hasRecordatoriosAccess: false,
    hasFinanzasAccess: false,
    hasPdfAccess: false,
    loading: true,
    error: null
  });

  useEffect(() => {
    const checkFeatures = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setFeatures(prev => ({ ...prev, loading: false }));
          return;
        }
        const response = await axios.get(`${API_BASE_URL}/api/suscripcion/estado/`, {
          headers: { Authorization: `Token ${token}` }
        });
        const { estado, plan } = response.data;
        const hasAccess = estado === 'Activa' && plan;

        const hasFin = hasAccess && plan.permite_acceso_finanzas;
        setFeatures({
          hasRecordatoriosAccess: hasAccess && plan.permite_recordatorios,
          hasFinanzasAccess: hasFin,
          hasPdfAccess: hasFin, // usa el mismo flag por ahora
          loading: false,
          error: null
        });
      } catch (error) {
        console.error('Error al verificar características de suscripción:', error);
        setFeatures({
          hasRecordatoriosAccess: false,
          hasFinanzasAccess: false,
          hasPdfAccess: false,
          loading: false,
          error: 'Error al verificar características de suscripción'
        });
      }
    };

    checkFeatures();
  }, []);

  return features;
};